import React from "react"
import { HandleImages } from "../components/functions"
import Layout from "../components/layout"
import "../css/leadership.css"
import SEO from "../components/seo"



var board = [
    {
        name: "Craig Asher",
        title: "Board Member",
        bio:
          "Craig Asher joined the Circadence® Board in October 2012. Asher has a successful track record of developing software companies and has been a key team member in three successful software startups: Commerce One; Trigo Technologies; and the internal IBM startup for InfoSphere Traceability Server. He has guided major software implementations with over 50 customers in markets including retail, medical products, pharmaceuticals, and general distribution.",
        image: <HandleImages name="placeholder" />,
      },
      {
        name: "John Harlan Jr",
        title: "Board Member",
        bio:
          "John M. Harlan, Jr. is the owner and president of The Harlan Company, a mid-sized general contractor located in St. Louis, Missouri. Founded in 1977, The Harlan Company manages both public and private projects throughout the United States and Eastern Europe.",
        image: <HandleImages name="placeholder" />,
      },
      {
        name: "John Kelley ",
        title: "Board Member",
        bio:
          "John Kelley joined the Circadence® board of directors in November 2009. Kelley is currently chairman of the board and CEO of privately held CereScan, Inc., a Denver-based brain diagnostic and scanning company focused on brain disorders and traumatic injuries. Kelley’s professional activities have included being a member of the board of directors of Polycom Corporation since 2000, and he is currently chair of its Nominating & Governance Committee.",
        image: <HandleImages name="placeholder" />,
      },
      {
        name: "Charles Lamphere",
        title: "Board Member",
        bio:
          "Charles R. Lamphere joined the Circadence® Board of Directors in October 2012. Lamphere is President and CEO of Van Vlissingen and Co., an Illinois headquartered commercial real estate developer. Lamphere is also a principal in Vital Financial, a Maryland based venture capital firm.",
        image: <HandleImages name="placeholder" />,
      },
      {
        name: "John Shoffner",
        title: "Board Member",
        bio:
          "John Shoffner joined the Circadence® Board in October 2012. From 1980 to 1997, Shoffner served as President and CEO of Dura-Line Corporation, a global manufacturer of fiber optic cable installation products and services serving the major telecommunication providers in over 60 countries.",
        image: <HandleImages name="placeholder" />,
      },
]

var content = [
  {
    name: "Michael J. Moniz",
    title: "Co-founder, President and CEO",
    bio:
      "Michael J. Moniz is the co-founder, President, and CEO of Circadence® and has established the company as a leader in cyber range, cybersecurity readiness, and risk mitigation solutions. Under his direction, Circadence has secured more than 40 patents, many focused on high-growth market segments such as cloud and mobile computing. Moniz co-founded VR-1, an early visionary in online multiplayer games, establishing titles such as Fighter Ace and UltraCorps on Microsoft’s Gaming Zone, seven titles with AOL and content distribution agreements with Sony.",
    image: <HandleImages name="mmoniz" />,
  },

  {
    name: "Christopher T. Blisard",
    title: "Co-Founder & Chief Operating Officer",
    bio:
      "With more than 20 years of operational, business development, and leadership experience, Christopher T. Blisard has led Circadence as COO since 1999. He manages day-to-day operations and is a fundamental force in creating major OEM, partnership, and cooperative technology agreements with corporations such as Hewlett-Packard, Network Equipment Technologies, Accenture, Dell, Microsoft, Deutsche Telekom, and others.",
    image: <HandleImages name="cblissard" />,
  },
 

  {
    name: "Peter-Christian Olivo",
    title: "Executive Vice President and General Counsel",
    bio:
      "Peter-Christian Olivo is the Executive Vice President, General Counsel and Secretary for Circadence since 2000. He is responsible for all transactional, intellectual property and regulatory matters for Circadence, including its government contracts, patent filings and risk management oversight. Olivo also oversees all human resource functions including hiring, performance management, employee development and compensation and benefit programs that help attract and retain the talent necessary to fuel Circadence’s growth.",
    image: <HandleImages name="polivo" />,
  },
  {
    name: "Bradley Hayes",
    title: "Chief Technology Officer",
    bio:<span>With decades of professional experience, Dr. Hayes’ expertise in Artificial Intelligence and Machine Learning supports continual innovation for Circadence’s cyber readiness solutions. Hayes teaches as a professor at the University of Colorado’s Department of Computer Science and serves as the Director of the Collaborative AI and Robotics (CAIRO) Lab. He has in-depth experience developing techniques to build autonomous AI that can learn from and collaborate with humans, making people more efficient and capable during task execution.
<br/><br/>
    His theoretical prowess drives his ability to deeply and technically understand the intricacies of the cybersecurity industry and put them into practice. Hayes previously served as a Software Engineer at BAE Systems and Software Design Engineer for Microsoft.
    <br/><br/>
     In addition to his work with ML/AI, Brad’s broad swath of expertise includes Learning from Demonstration, Hierarchical Reinforcement Learning, Activity Recognition, Behavioral Modeling, Computer Vision, Natural Language Processing, Cognitive Science, Deep Learning, and Human-Robot Interaction.</span>,
        image: <HandleImages name="bhayes" />,
  },
  {
    name: "R. Bradley Prewitt",
    title: "Executive Vice President of Government Relations and Development",
    bio:
      "With over 20 years as an attorney, political advisor, business developer and strategic thinker, R. Bradley Prewitt has served on Circadence’s Executive Team since 2007. Prewitt led the corporate initiative to locate Circadence’s Product Development and Advanced R&D Center in Tupelo, Mississippi, where he is based. Prior to his work with Circadence, Prewitt worked as a defense lawyer in a civil litigation firm and later as general counsel to United States Senator Thad Cochran (R-MS) on Capitol Hill",
    image: <HandleImages name="rprewitt" />,
  },
  {
    name: "Ian MacLeod",
    title: "Senior Vice President of Engineering",
    bio:
      "Ian MacLeod is the Senior Vice President of Engineering at Circadence. Ian draws upon his experience in the technology/AI domain and government sector to inform his responsibilities for Circadence product development and engineering efforts. Previously, Ian was the Director of Platform Development at Fractal Industries Inc., a start-up software firm that applies artificial intelligence to solve complex real-world problems at scale. Under his leadership at Fractal, he grew a global team of over 50 developers, engineers, and managers, building a cutting-edge, multi-cloud platform designed to democratize AI across any domain. Prior to Fractal, he served as the Senior Technical Advisor within the U.S. Office of the Secretary of Defense for Cyber Policy and was a plank-holder of the U.S. Army Cyber Command where he filled numerous positions, including the Technology Director of the Advanced Concepts and Technology Directorate. Ian is a 2002 graduate of the United States Military Academy at West Point where he earned a degree in Computer Science and was commissioned as a Signal Officer. He served a total of six years on active duty, leading critical communications operations in support of strategic objectives before working as a Lead Systems Engineer managing the development of secure broadband multi-national radio systems in the private sector. Ian, his wife Hilary, and young son Eli live in Arlington, VA.",
    image: <HandleImages name="imacleod" />,
  },
 
  {
    name: "Wes Knee",
    title: "Vice President of Marketing & Creative",
    bio:<span>Mr. Knee’s decade-long professional background is best described as artistic. And that’s exactly what he brings to the leadership table at Circadence, seamlessly managing both marketing and creative departments to bring forth a compelling visual and written brand identity that sets the company apart. In this role, Mr. Knee enjoys distilling the complex world of cybersecurity into digestible messages apt for anyone to comprehend, helping audiences navigate the world of cyber with a greater degree of confidence.
<br/><br/>
    Prior to Circadence, Mr. Knee worked as a Lead Artist on commercial mobile games including Kung Fu Panda, How to Train Your Dragon, and Jurassic World. His expertise in 3D art, animation, and Marketing, have helped him understand the value of diverse skill sets in the professionals he manages today.
    <br/><br/>
    Mr. Knee holds a bachelor’s degree in Interactive Development and Game Design/3D Art and Animation and is a Suma Cum Laude graduate. In this spare time, he enjoys the outdoors, primarily hiking and exploring caves.</span>,
    image: <HandleImages name="wknee" />,
  },
  {
    name: "Todd Kannegieter",
    title: "Vice President of Finance",
    bio:
      "With over three decades of finance and accounting experience, Todd L. Kannegieter has served as Vice President of Finance for Circadence Corporation since 2001. Kannegieter is responsible for the overall financial management of the company, its financial reporting and transparency, and for multiple corporate functions including investor relations, treasury management and long-range financial planning.",
    image: <HandleImages name="tkannegieter" />,
  },
  {
    name: "Joshua Selfe",
    title: "Vice President of Strategic Innovation",
    bio:
      "Joshua Selfe has more than 14 years of experience successfully tearing down barriers and challenging perceptual limitations in order to make end-users more productive and efficient. Selfe joined Circadence in 2018 to champion the synthetization of knowledge to facilitate company and product vision, execution, culture, team performance and business growth.",
    image: <HandleImages name="jselfe" />,
  },
  {
    name: "Karl Gossett",
    title: "Vice President of Content Development",
    bio:
      "Karl Gossett is the Vice President of Content Development at Circadence. He works with a world-class team of cyber operators to develop content across a learning continuum for Circadence’s platforms. Under his leadership, his team develops general security awareness and advanced cyber security learnings for enterprise, government, and academic institutions to train personnel, evaluate competencies, and certify skills that ultimately help reduce organizational risk",
    image: <HandleImages name="kgossett" />,
  },
  {
    name: "Craig Koroscil",
    title: "Vice President of Cyber Education and Training",
    bio:
      "Craig Koroscil joined Circadence bringing with him over 17 years of cyber operations, information security and computer science experience. Mr. Koroscil leads the Company’s efforts to combine world-class cyber operations experience with innovative solutions to provide training, evaluation, and certification paths that enable clients to meet their cybersecurity goals.",
    image: <HandleImages name="ckoroscil" />,
  },
]
class Covid extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            active:0,
        visible:false
        }
        this.handleClose = this.handleClose.bind(this);
      }
  handleClick(event) {
    event.target.parentNode.parentNode.parentNode.id = event.target.id
    this.setState({
      section:event.target.id
    })
  }


  handleClose(){
      
      
    this.setState({
       
        visible:false
    })
  }

  handleChildClick (event) {
    event.stopPropagation();
    console.log('child');
  }

  handlePersonClick(event){

    this.setState({
        active:event.target.parentNode.parentNode.id,
        visible:true,
      
    })
      

  }

  render() {
    return (
      <Layout>
        <SEO title="Executive Team | Leadership" description="Meet the executive team at Circadence and learn how their expertise is driving cyber readiness innovation for enterprise, government, and academic institutions."/>
        <div className="basic-hero mounted leadership executives" id="executives">
          <div>
            <div>
              <h1>Leadership</h1>
              <p>
                The Circadence executive team and board of directors is
                comprised of the best and brightest in the cyber and business
                industries. Our executive leadership has <strong>more than 250 combined
                years of experience</strong> driving innovation, business growth, and
                cyber defense for leading enterprises, academic and federal
                agencies. Leadership and the board members possess <strong>deep passion
                for service and unwavering commitment</strong> to protecting national
                security.
              </p>
            </div>
            <div className="tabs" id="executives">
              <button
                name="Executive Team"
                className="outlined-button"
                id="executives"
                onClick={event => this.handleClick(event)}
              >
                Executive Team
              </button>
              <button
                name="Board Members"
                className="outlined-button"
                id="board"
                onClick={event => this.handleClick(event)}
              >
                Board Members
              </button>
            </div>
          </div>
          <div>
            <HandleImages name="crowd" />
          </div>
        </div>

        <div className="people-wrapper execs">
          {content.map((person, index) => {
            return (
              <li className='person-wrapper' id={index} >
             <h3>{person.title}</h3> 
             {person.image}
       <div><span> {person.name}</span>
        <button name="expand" className="round-button"onClick={(event)=>this.handlePersonClick(event)}>+</button></div> 
              </li>
            )
          })}
        </div>

        
        <div className="people-wrapper board">
          {board.map((person, index) => {
            return (
              <li className='person-wrapper' id={index} >
             <h3>{person.title}</h3> 
          
       <div><span> {person.name}</span>
        <button name="expand" className="round-button"onClick={(event)=>this.handlePersonClick(event)}>+</button></div> 
              </li>
            )
          })}
        </div>
<div className={this.state.visible?"bio-wrapper visible":"bio-wrapper"} onClick={this.handleClose}>
    <div onClick={this.handleChildClick}>
    <button name="close" className="round-button"  onClick={this.handleClose}>×</button> 
        <h3>{this.state.section=="board"?board[this.state.active].title:content[this.state.active].title}</h3>
        {this.state.section=="board"?"": content[this.state.active].image}
      <span>  {this.state.section=="board"?board[this.state.active].name:content[this.state.active].name}</span>
        <p>{this.state.section=="board"?board[this.state.active].bio:content[this.state.active].bio}</p>

    </div>
</div>

      </Layout>
    )
  }
}

export default Covid
